// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"a5c5df07","865":"1970eb01"}[chunkId] + ".chunk.js";
};